import React from 'react'
import BooksList from '../books/BooksList'
import { routeName } from '../../../../routes/routeName'
import { ELibraryCategory } from '../../enum/elibrary_enum'

type Props = {}

const AudioBooksList: React.FC<Props> = ({ }: Props) => {
    return (
        <BooksList
            category_label='หนังสือเสียง'
            category_path={routeName.e_library.audio_book}
            category_pathname_label={routeName.e_library.audio_book_list}
            library_category_name={ELibraryCategory.AUDIO_BOOK}
            path_detail={routeName.e_library.audio_book_detail}
            allow_shadow={true}
            allow_view_audio={true}
        />
    )
}

export default AudioBooksList